var _defs, _g, _g2, _g3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveyIcons1 = function SvgSurveyIcons1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "SurveyIcons-1_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 45 45"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".SurveyIcons-1_svg__cls-1{fill:#fff}.SurveyIcons-1_svg__cls-2{fill:#4f6b80}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SurveyIcons-1_svg__mask-2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SurveyIcons-1_svg__mask-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SurveyIcons-1_svg__path-3",
    d: "M24.1 17.93h20.73v20.74H24.1V17.93z",
    className: "SurveyIcons-1_svg__cls-1"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SurveyIcons-1_svg__mask"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SurveyIcons-1_svg__mask-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SurveyIcons-1_svg__path-1",
    d: "M18.43 5.67h16.04v4.64H18.43V5.67z",
    className: "SurveyIcons-1_svg__cls-1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "SurveyIcons-1_svg__Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SurveyIcons-1_svg__regular-survey"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SurveyIcons-1_svg__product-test"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SurveyIcons-1_svg__Group-13"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SurveyIcons-1_svg__Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SurveyIcons-1_svg__Fill-1",
    d: "m33.87 10.09-5.56-4.28a.72.72 0 0 0-.44-.15h-8.58a.72.72 0 0 0-.72.72v3a.72.72 0 0 0 .72.72Z",
    className: "SurveyIcons-1_svg__cls-2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "SurveyIcons-1_svg__Fill-4",
    d: "M15.6 5.67H7.11a.72.72 0 0 0-.44.15l-5.5 4.27H15.6a.72.72 0 0 0 .72-.71v-3a.72.72 0 0 0-.72-.72",
    className: "SurveyIcons-1_svg__cls-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SurveyIcons-1_svg__Group-8",
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "SurveyIcons-1_svg__Fill-6",
    d: "M33.87 17.36a9.89 9.89 0 1 0 9.88 9.9 9.91 9.91 0 0 0-9.88-9.89m0 2.09a7.8 7.8 0 1 1-7.8 7.8 7.8 7.8 0 0 1 7.8-7.8",
    style: {
      fill: "#f05e25"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "SurveyIcons-1_svg__Fill-9",
    d: "m33 31.88-3.81-3.52a1 1 0 1 1 1.4-1.54l2.26 2.06 4.43-5.36a1 1 0 0 1 1.59 1.34Z",
    style: {
      isolation: "isolate",
      fill: "#f05e25",
      opacity: 0.7
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "SurveyIcons-1_svg__Fill-11",
    d: "M22.59 27.25A11.29 11.29 0 0 1 33.87 16v-3a.72.72 0 0 0-.72-.72H9.59a.72.72 0 0 0-.72.72v3.38L6.25 19a.72.72 0 0 1-1 0l-2.6-2.6V13a.72.72 0 0 0-.72-.72.72.72 0 0 0-.73.72v22.2A3.74 3.74 0 0 0 4.94 39h25.2a3.72 3.72 0 0 0 2-.57 11.29 11.29 0 0 1-9.53-11.14",
    className: "SurveyIcons-1_svg__cls-2"
  })))))));
};
export default SvgSurveyIcons1;